// extracted by mini-css-extract-plugin
export default {"ruleContainer":"ScoreRule_ruleContainer__njOx+","ruleError":"ScoreRule_ruleError__JULWs","cross":"ScoreRule_cross__930gX","inputDefault":"ScoreRule_inputDefault__54q7x"};